export enum ProfileStatusDetail {
    ROBLOX = 'roblox',
    VIDEO = 'video',
    CALL = 'call',
}